// extracted by mini-css-extract-plugin
export default {"content":"style_content__ba0jk","vertical":"style_vertical__dBv6w","wrapper":"style_wrapper__i9jwp"};